import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const Backdrop = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: all 0.3s ease-in-out;
`;

const ModalWindow = styled.div`
  background-color: var(--color-white);
  max-width: ${({ $variant }) => ($variant === "big" ? "1350px" : "600px")};
  max-height: 100vh;
  height: ${({ $variant }) => ($variant === "big" ? "auto" : "100vh")};
  width: 100%;
  margin: auto;
  border-radius: var(--border-radius);
  -ms-overflow-style: none;
  scrollbar-width: none;
  scrollbar-width: none;
  overflow-y: scroll;
  position: fixed;
  z-index: 99999;
  transition: all 0.3s ease-in-out;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 100vh;
    width: 100%;
  }
  &.animate-top {
    top: ${({ $isOpen }) => ($isOpen ? "50%" : "0")};
    transform: ${({ $isOpen }) =>
      $isOpen ? "translateY(-50%)" : "translateY(-100%)"};
  }
  &.animate-right {
    top: ${({ $variant }) => ($variant === "big" ? "50%" : "0")};
    right: ${({ $isOpen, $variant }) =>
      $isOpen && $variant === "big" ? "50%" : "0"};
    transform: ${({ $isOpen, $variant }) =>
      $isOpen && $variant === "big"
        ? "translate(50%, -50%)"
        : $isOpen && $variant != "big"
        ? "translate(0,0)"
        : !$isOpen && $variant != "big"
        ? "translate(100%,0)"
        : "translate(100%, -50%)"};
  }
  &.animate-bottom {
    bottom: ${({ $isOpen }) => ($isOpen ? "50%" : "0")};
    transform: ${({ $isOpen }) =>
      $isOpen ? "translateY(50%)" : "translateY(100%)"};
  }
  &.animate-left {
    top: ${({ $variant }) => ($variant === "big" ? "50%" : "0")};
    left: ${({ $isOpen, $variant }) =>
      $isOpen && $variant === "big" ? "50%" : "0"};
    transform: ${({ $isOpen, $variant }) =>
      $isOpen && $variant === "big"
        ? "translate(-50%, -50%)"
        : $isOpen && $variant != "big"
        ? "translate(0,0)"
        : !$isOpen && $variant != "big"
        ? "translate(-100%,0)"
        : "translate(-100%, -50%)"};
  }
`;

const CloseIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  position: absolute;
  top: 30px;
  right: 35px;
`;

export default function Modal({
  children,
  animateFrom,
  variant,
  isOpen,
  onClose,
}) {
  return (
    <>
      <ModalWindow
        $isOpen={isOpen}
        $variant={variant}
        onClick={(e) => e.stopPropagation()}
        className={`animate-${animateFrom}`}
      >
        <CloseIcon icon={faTimes} size="xl" onClick={onClose} />
        {children}
      </ModalWindow>
      <Backdrop $isOpen={isOpen} onClick={onClose}></Backdrop>
    </>
  );
}

Modal.propTypes = {
  children: PropTypes.node,
  animateFrom: PropTypes.oneOf(["top", "right", "bottom", "left"]),
  variant: PropTypes.oneOf(["big", "small"]),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
